import {
  KPI_COLORS as KPI_COLORS_COMMON,
  stateColorOption,
  statusColorOption
} from '@fareye/configs'
export const GRAPH_DATA_MAPPING = {
  condition: {
    value: 'value',

    label: 'label'
  },
  dataSource: {
    label: 'label',

    value: 'value'
  },
  dimension: {
    value: 'value',

    label: 'label'
  },
  filterType: {
    value: 'value',

    label: 'label'
  },
  filterKey: {
    value: 'value',

    label: 'label'
  },
  filterValue: {
    label: 'label',

    value: 'value'
  },
  metricKey: {
    value: 'value',

    label: 'label'
  },
  metricType: {
    value: 'value',

    label: 'label'
  },
  sortKey: {
    value: 'value',

    label: 'label'
  },
  sortType: {
    value: 'value',

    label: 'label'
  },
  pageIdList: {
    value: 'key',

    label: 'value'
  },
  unit: {
    value: 'key',

    label: 'value'
  }
}

export const SHIPMENT_TYPES = [
  { label: 'Shipment', value: 'Journey', dataSource: 'Journey' },
  { label: 'Package', value: 'Shipment', dataSource: 'Shipment' }
  // { label: 'Item', value: 'item', dataSource: 'Item' }
]
